<template>
  <div class="hold" style="padding: 0;">
    <div class="valign-center" v-if="loading">
      <div class="spinner">
        <broken-spinner color="#554971" :thickness="2"/>
      </div>
    </div>
    <div class="container-fluid bg-light p-5" id="cf" v-else>
      <div class>
        <div class="row job-container">
          <div class="col-sm-12 search-widget ml-3 col-lg-3">
            <div class="sticky">
              <span
                style="padding: 5px; font-weight:600; padding-bottom: 10px !important; color: #6b6b6b;"
                @click="() => toggleFilter = !toggleFilter"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="14px"
                  height="14px"
                  viewBox="0 0 971.986 971.986"
                  style="enable-background:new 0 0 971.986 971.986;"
                  xml:space="preserve"
                  class
                >
                  <g>
                    <g>
                      <path
                        d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3   c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873   c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="##4D4F5"
                        fill="rgba(77, 79, 92, 0.5)"
                      ></path>
                    </g>
                  </g>
                </svg>
                Filter Jobs
              </span>
              <br>
              <div class="card mr-5 search_card" :class="{toggleFilter}">
                <div class="row form-group">
                  <div class="col-sm-12">
                    <small>Select Class group</small>
                    <select class="form-control search-form" id="classgroup" v-model="classgroup">
                      <option :value="null" selected>Select Class group</option>
                      <option :value="cg.id" v-for="cg of classGroups" :key="cg.id">{{ cg.name }}</option>
                    </select>
                  </div>
                  <div class="col-sm-12">
                    <small>Select Subject</small>
                    <select
                      class="form-control search-form"
                      id="subjects"
                      name="subjects"
                      v-model="subject"
                    >
                      <option :value="null" selected>Select Subject</option>
                      <option :value="sub.id" v-for="sub of subjects" :key="sub.id">{{ sub.name }}</option>
                    </select>
                  </div>

                  <div class="col-sm-12">
                    <small>Select State</small>
                    <select
                      class="form-control search-form"
                      id="states"
                      name="states"
                      v-model="state"
                    >
                      <option :value="null" selected>Select State</option>
                      <option :value="st.id" v-for="st of states" :key="st.id">{{ st.name }}</option>
                    </select>
                  </div>

                  <div class="col-sm-12">
                    <small>Select Location</small>
                    <select
                      class="form-control search-form"
                      id="locations"
                      name="locations"
                      v-model="location"
                    >
                      <option :value="null" selected>Select Location</option>
                      <option
                        v-for="lc of formatedLocations"
                        :key="lc.id"
                        :value="lc.id"
                      >{{ lc.name }}</option>
                    </select>
                  </div>

                  <div class="col-sm-12">
                    <small>Select Gender</small>
                    <select class="form-control search-form" name="gender" v-model="gender">
                      <option :value="null">Any</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>

                   <div class="col-sm-12">
                    <small>Select Class Type</small>
                    <select class="form-control search-form" name="classtype" v-model="classtype">
                      <option :value="null">Any</option>
                      <option value="online">Online Classes</option>
                      <option value="offline">Offline Classes</option>
                    </select>
                  </div>

                  <div class="col-sm-12 col-lg-6">
                    <small>Date Posted (From)</small>
                    <input
                      type="date"
                      name="date_posted_from"
                      class="form-control date-input search-form"
                      v-model="date_posted_from"
                    >
                  </div>
                  <div class="col-sm-12 col-lg-6">
                    <small>Date Posted (To)</small>
                    <input
                      type="date"
                      name="date_posted_to"
                      class="form-control date-input search-form"
                      v-model="date_posted_to"
                    >
                  </div>
                  <div class="col-sm-12">
                    <small>Search with Status</small>
                    <select
                      class="form-control search-form"
                      id="locations"
                      name="status"
                      v-model="status"
                    >
                      <option :value="null">Any</option>
                      <option value="verified">Concluded</option>
                      <option value="unverified">Negotiable</option>
                    </select>
                  </div>

                  <div class="col-sm-12">
                    <button class="submit-button btn btn-success" @click="buildSearch">Search</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-lg-8 cc-card content-card" style="margin-bottom: 100px;">
            <span
              class="pl-5 text-small"
              style="padding: 5px; padding-bottom: 10px !important; font-weight: 600; color: #6b6b6b;"
            >
              All Jobs
              <span
                class="float-right pr-5"
                style="font-weight: 300 !important; font-size: 12px;"
              >Showing {{ this.pagination.meta && this.pagination.meta.from }} - {{ this.pagination.meta && this.pagination.meta.to }} of {{ this.pagination.meta && this.pagination.meta.total }}</span>
            </span>
            <br>
            <div
              class="card content-card mb-5"
              style="height:100%; padding: 0; padding-bottom: 10px !important;"
            >
              <fragment v-if="fetchingJobs">
                <div class="spinner-wrapper">
                  <div class="spinner">
                    <broken-spinner color="#554971" :thickness="2"/>
                  </div>
                </div>
              </fragment>
              <fragment v-else>
                <fragment>
                  <verified-jobs-component
                    :key="job.id"
                    v-for="job of verified_jobs"
                    :verified="true"
                    :job="job"
                    :jobs="job.jobs"
                  />
                  <jobs-component
                    :key="job.id"
                    v-for="job of unverified_jobs"
                    :verified="false"
                    :job="job"
                    :jobs="job.jobs"
                  />
                </fragment>
                <center v-if="jobs.data.length === 0" class="pt-5 mt-5" >
                  <svg width="54px" height="54px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 470.333 470.333" style="enable-background:new 0 0 470.333 470.333;" xml:space="preserve"><g><g><path d="M235.167,470.333c129.767,0,235.167-105.4,235.167-235.167S364.933,0,235.167,0S0,105.4,0,235.167 S105.4,470.333,235.167,470.333z M235.167,34c110.783,0,201.167,90.383,201.167,201.167S345.95,436.333,235.167,436.333 S34,345.95,34,235.167S124.383,34,235.167,34z" /><path d="M164.333,196.633c7.083,0,13.883-2.833,18.983-7.933c10.483-10.483,10.483-27.483,0-37.967 c-5.1-5.1-11.9-7.933-18.983-7.933s-13.883,2.833-18.983,7.933c-10.483,10.483-10.483,27.483,0,37.967 C150.45,193.8,157.25,196.633,164.333,196.633z" /><path d="M299.2,196.633c7.083,0,13.883-2.833,18.983-7.933c10.483-10.483,10.483-27.483,0-37.967 c-5.1-5.1-11.9-7.933-18.983-7.933s-13.883,2.833-18.983,7.933c-10.483,10.483-10.483,27.483,0,37.967 C285.317,193.8,291.833,196.633,299.2,196.633z" /><path d="M157.25,328.667c0.567-1.7,11.617-38.25,73.667-38.25c64.033,0,82.167,38.817,82.733,40.233 c2.833,6.517,9.067,10.483,15.583,10.483c2.267,0,4.25-0.283,6.517-1.417c8.783-3.683,12.75-13.6,9.067-22.1 c-1.133-2.55-26.35-61.2-114.183-61.2c-89.533,0-105.967,61.2-106.533,63.75l16.433,4.25L157.25,328.667z" /></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                  <h3>Aww, Snap.</h3>
                  There are no Jobs that matches your search.
                </center>
              </fragment>
              <nav>
                <paginate
                  v-model="page"
                  :page-count="pagination.meta.last_page || null"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="paginationClickCallback"
                  :prev-text="'<<'"
                  :next-text="'>>'"
                  :container-class="'pagination justify-content-center'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :prev-link-class="'page-link'"
                  :next-link-class="'page-link'"
                ></paginate>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Paginate from "vuejs-paginate";
import { mapState, mapGetters } from "vuex";
import JobsComponent from "./JobsComponent";
import VerifiedJobsComponent from "./VerifiedJobsComponent";
import BrokenSpinner from "@/components/Preloaders/BrokenSpinner";

export default {
  name: "TutoringJobs",
  components: {
    Paginate,
    BrokenSpinner,
    JobsComponent,
    VerifiedJobsComponent
  },
  data() {
    return {
      api: `${BASE_API}/v1/tutor/tutoring-jobs`,
      withConcerns: [
        "sessionClasses.subjects",
        "location",
        "sessionClasses.client",
        "sessionClasses.client.location",
        "sessionClasses.client.state",
        "sessionClasses.location",
        "sessionClasses.classGroups",
        "sessionClasses.location.state",
        "sessionClasses.learners",
        "clientRequests"
      ],
      jobs: [],
      verified_jobs: [],
      unverified_jobs: [],
      fetchingJobs: true,
      classgroup: this.$route.query.classgroup || null,
      subject: this.$route.query.subject || null,
      state: this.$route.query.state || null,
      location:this.$route.query.location || null,
      gender: this.$route.query.gender || null,
      classtype: this.$route.query.classtype || null,
      date_posted_from: this.$route.query.date_posted_from || null,
      date_posted_to: this.$route.query.date_posted_to || null,
      status: this.$route.query.status || null,
      loading: true,
      page: this.$route.query.page || 1,
      pagination: {},
      toggleFilter: true
    };
  },
  computed: {
    ...mapState("profile", ["states", "locations"]),
    ...mapGetters("profile", ["locationsByState", "locationsByStateId"]),
    classGroups() {
      return this.$store.getters.classgroups;
    },
    subjects() {
      return this.$store.getters.subjects;
    },
    orderedUsers: function() {
      if (this.verified_jobs && this.verified_jobs.length > 0) {
        console.log(this.verified_jobs);
        return _.orderBy(this.verified_jobs, "id");
      }
    },
    formatedLocations() {
      if (this.state !== null) {
        const { state } = this;
        const lbs = this.locationsByStateId(state);
        console.log(lbs);
        if (!lbs.find(x => x.id === this.location)) {
          this.location = null;
        }
        return lbs;
      }
      return this.locations;
    }
  },
  methods: {
    getJobs(route = null) {
      const page = this.$route.query.page || 1;
      const w = this.withConcerns.join(",");
      const r = route || this.$route;
      const filters = this.buildFilters(r);
      return new Promise((resolve, reject) => {
        axios
          .get(`${this.api}?page=${page}&with=${w}${filters}`)
          .then(({ data }) => {

            // this.fetchingJobs = false;

            this.jobs = data.jobs;
            console.log(this.jobs);
            // console.log(data.data);
            this.verified_jobs = data.verified_jobs.data;
            this.unverified_jobs = data.unverified_jobs.data;
            this.verified_jobs = _.orderBy(
              this.verified_jobs,
              "updated_at"
            ).reverse();
            this.unverified_jobs = _.orderBy(
              this.unverified_jobs,
              "client_requests.updated_at"
            ).reverse();
            // console.log(filteredData);
            console.log('this jobs');
            console.log(data.jobs);

            this.$set(this.pagination, "links", data.jobs.links);
            this.$set(this.pagination, "meta", data.jobs);
            resolve(data);
          })
          .catch(() => reject());
      });
    },
    buildFilters(r) {
      return Object.entries(r.query).reduce(
        (accumulator, [key, value]) => `${accumulator}&${key}=${value}`,
        ""
      );
    },
    buildSearch() {
      const query = {};
      // subject filter
      if (this.subject !== null && this.subject !== "") {
        query["subject"] = this.subject;
      }
      // classgroup filter
      if (this.classgroup !== null && this.classgroup !== "") {
        query["classgroup"] = this.classgroup;
      }
      // state filter
      if (this.state !== null && this.state !== "") {
        query["state"] = this.state;
      }

      //date posted from
      if (this.date_posted_from !== null && this.date_posted_from !== "") {
        query["date_posted_from"] = this.date_posted_from;
      }

      //date posted to
      if (this.date_posted_to !== null && this.date_posted_to !== "") {
        query["date_posted_to"] = this.date_posted_to;
      }
      // location filter
      if (this.location !== null && this.location !== "") {
        query["location"] = this.location;
      }
      // gender filter
      if (this.gender !== null && this.gender !== "") {
        query["gender"] = this.gender;
      }
      // class type filter
      if (this.classtype !== null && this.classtype !== "") {
        query["classtype"] = this.classtype;
      }
      // status filter
      if (this.status !== null && this.status !== "") {
        query["status"] = this.status;
      }

      return this.$router.push({ name: "tutoring-jobs", query }).catch(() => {});
      // return this.$router.go();
    },
    paginationClickCallback(p) {
      const query = { ...this.$route.query };
      query.page = p;
      return this.$router.push({ name: "tutoring-jobs", query }).catch(() => {})
    }
  },
  mounted() {
    console.log(console.log(this.$auth.user().notifications))
    Promise.all([
      this.$store.dispatch("getSubjects"),
      this.$store.dispatch("getClassGroups"),
      this.$store.dispatch("getTutorLocation"),
      this.$store.dispatch("profile/getStates"),
      this.$store.dispatch("profile/getLocations")
    ])
      .then(() => {
        console.log('make fetch job false');
        this.loading = false;
        this.getJobs().then(() => {
        });
        this.fetchingJobs = false;

        // .catch(() => { alert('Couldn\'t load jobs! Please try again'); });
      })
      .catch(() => console.trace());
  },
  beforeRouteUpdate(to, from, next) {

    this.fetchingJobs = true;

    // console.log(this.fetchingJobs);
    this.getJobs(to).then(() => {

    });

    next()
    // .catch(() => { alert('Couldn\'t load jobs! Please try again'); });

  }
};
</script>

<style type="text/css" scoped>
* {
  color: #6b6b6b;
}
.valign-center {
  height: calc(100vh - 105px);
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}
.spinner {
  float: center;
  margin: 0 auto;
}
.spinner-wrapper {
  padding: 40px;
  width: 100%;
  height: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;
}
.card {
  border-radius: 0px !important;
  height: 100% !important;
  margin-bottom: 40px;
}
.svg-wrap {
  position: relative;
  display: inline-block;
}
.sticky {
  position: sticky;
  top: 50px;
}
.content-card {
  width: 90%;
  /* margin: 0 auto !important; */
  margin-left: 50px !important;
}
.btn-smallie {
  height: 40px !important;
  border: 1px solid green;
  font-size: 12px;
}
.job-content-sub {
  font-size: 13px;
}
.shift-sf {
  width: 55%;
}
.page-item.active .page-link {
  background-color: #5e9047;
  border-color: #5e9047;
}
.page-link {
  color: #5e9047;
}
.search_card {
  height: 620px !important;
  width: 320px;
  padding-top: 20px;
  padding-bottom: 50px;
}
.search-widget {
  margin-left: -30px;
}
.job-content {
  margin: 30px;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 10px;
}
.job-content-details {
  padding-top: 7px;
  border-top: 1px solid #f7f7f7;
  margin-top: 10px;
}
.job-content-header,
.job-content-client {
  color: #5e9047;
  cursor: pointer;
}
.job-content-client {
  font-size: 12px;
  font-weight: 600;
  font-family: "Montserrat";
  color: black;
  opacity: 0.4;
}
.job-content-header {
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 25px;
  line-height: 1.5em;
}
.job-content-time {
  opacity: 0.5;
  font-weight: 600;
  font-size: 13px;
  font-family: "Montserrat";
}
.sticky-card {
  position: sticky;
  top: 0;
  position: -webkit-sticky;
}
.btn-job {
  width: 130px;
  height: 30px;
  line-height: 35px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
  vertical-align: middle;
  background: #5f9048;
  border: #5f9048;
  color: white;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14),
    0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
}
.vl {
  border-left: 1px solid green;
  height: 100vh;
  margin-top: -50px;
  margin-left: 40px;
  z-index: 0;
  opacity: 0.2;
  margin-right: 20px;
}
.form-group {
  margin: 8px;
}
.search-form {
  margin-bottom: 10px;
  font-size: 13px !important;
  border-radius: 0px !important;
}
label {
  font-weight: 600;
}
button.btn-search {
  width: 100% !important;
  height: 30px;
  line-height: 35px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
  vertical-align: middle;
  background: #5f9048;
  border: #5f9048;
  color: white;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14),
    0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
}
select {
  border-radius: 0px;
  font-size: 13px;
}
@media only screen and (max-width: 600px) {
  .vl {
    display: none;
  }
  .search_card {
    width: 100% !important;
  }
  .btn-job {
    width: 50%;
    height: 20% !important;
    margin-top: -10px !important;
    background: transparent;
    color: #5e9047;
    max-height: 20px !important;
    box-shadow: none;
    font-weight: 600;
  }
  .content-card {
    margin-left: 10px !important;
    width: 96% !important;
  }
  .cc-card {
    border-left: 0px !important;
    width: 100% !important;
    padding: 10px;
  }
  .sticky {
    position: relative !important;
    top: 0 !important;
  }
  .job-container {
    margin-left: -60px;
    width: 100vw;
  }
  .job-content-header {
    font-size: 15px;
  }
  .btn-smallie {
    margin-left: 0px !important;
    margin-top: 5px;
  }
  .text-small {
    font-size: 13px;
    padding-left: 1em !important;
  }
}
</style>

<style lang="scss" scoped>
.hold {
  margin: 25px;
}
.card {
  margin-top: 10px;
  border-radius: 2px;
  box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14),
    0 3px 1px -2px rgba(150, 150, 150, 0.12),
    0 1px 5px 0 rgba(150, 150, 150, 0.2);

  .tabs {
    display: flex;
    padding: 0 40px;
    height: 48px;
    width: 100%;
    margin: 0;

    .tab {
      display: inline-block;
      text-align: center;
      line-height: 48px;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid #b2b2b2;
      color: #b2b2b2;
      position: relative;
      overflow: hidden;
      cursor: pointer;

      &.router-link-exact-active {
        &::after {
          background: #639440;
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0%;
        }

        color: #333333;
      }
      // &.active { border-bottom: 2px solid #639440; }
    }
  }
}
.submit-button {
  width: 100%;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  float: right;
  color: #fff !important;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14),
    0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &.btn-default {
    box-shadow: 0 2px 2px 0 rgba(112, 112, 112, 0.14),
      0 3px 1px -2px rgba(112, 112, 112, 0.12),
      0 1px 5px 0 rgba(112, 112, 112, 0.2);
  }
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {
      box-shadow: none !important;
    }
  }
}
.job_section {
  .ls {
    .sls {
      position: sticky;
      top: 100px;
      background-color: #fcfcfc;
    }
    .top {
      height: 64px;
      display: flex;
      flex-direction: row;
      align-items: stretch;
      justify-content: flex-start;
      margin-bottom: 35px;
      .flt {
        font-size: 14px;
        font-weight: 600;
        color: rgba(77, 79, 92, 0.5);
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: row;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        border-right: 1px solid rgba(112, 112, 112, 0.3);
        svg {
          margin-right: 5px;
        }
      }
      .srch {
        width: 100%;
        height: 100%;
        padding: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        input {
          font-size: 14px;
          width: 90%;
          height: 40px;
          box-shadow: 0 2px 2px 0 rgba(200, 200, 200, 0.14),
            0 3px 1px -2px rgba(200, 200, 200, 0.12),
            0 1px 5px 0 rgba(200, 200, 200, 0.2);
          border: 1px solid rgba(112, 112, 112, 0.02);
          padding: 15px;
          transition: all 0.29s ease;
          border-radius: 4px;
          &:focus {
            width: 100%;
            box-shadow: 0 8px 17px 2px rgba(200, 200, 200, 0.14),
              0 3px 14px 2px rgba(200, 200, 200, 0.12),
              0 5px 5px -3px rgba(200, 200, 200, 0.2);
          }
        }
      }
      &:hover {
        .flt {
          color: #639440;
        }
      }
    }
    .bttm {
      width: 100%;
      padding: 25px 0;
      .form-group {
        margin-bottom: 20px;
        label {
          font-size: 13px;
          color: #639440;
          font-weight: 600;
          text-transform: uppercase;
        }
        select {
          border: 1px solid #95989a;
          border-radius: 0 !important;
          height: 42px;
          font-size: 14px;
        }
      }
    }
  }
  .rs {
    border-left: 1px solid rgba(0, 0, 0, 0.05);
    .tp {
      width: 100%;
      padding: 15px;
      position: relative;
      font-size: 22px;
      color: #576271;
      font-weight: 600;
      .sasasa {
        position: absolute;
        height: 1px;
        width: 100%;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
        background-color: rgba(0, 0, 0, 0.05);
        bottom: 0;
        margin-bottom: 20px;
      }
      p {
        font-size: 22px;
        color: #576271;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          font-size: 12px;
          background-color: #639400;
          color: #ffffff;
          padding: 3px 16px;
          border-radius: 16px;
          margin-left: 10px;
        }
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  .vl {
    display: none;
  }
  div.float-left {
    margin-left: 0 !important;
    margin-bottom: 25px;
  }
  .job_section {
    .rs {
      .tp {
        .sasasa {
          width: calc(100% - 30px);
        }
      }
    }
  }
}
</style>

<style lang="scss">
.pagination {
  .page-link {
    color: #888888;
    opacity: 0.8;
    margin: 0 4px;
  }
  .page-item {
    &.active {
      .page-link {
        background-color: #5f9048;
        border-color: #5f9048;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/TutoringJobs/TutoringJobs.vue